const selectors = {
  };
  class templateCollectionJS {
    constructor() {
      var viewAllFilter = document.querySelectorAll('.filter__item.view_all_block');
      if (viewAllFilter.length > 0) {
        this.showAllFilter(viewAllFilter);
      }
    }

    // show all filter for the filters
    showAllFilter(viewAllFilter) {
      viewAllFilter.forEach(item => {
        item.addEventListener('click', (e) => {
          var fieldset = item.closest('fieldset');
          if (fieldset != null) {
            var allFields = fieldset.querySelectorAll('.filter__item:not(.view_all_block)');
            if (allFields.length > 0) {
              allFields.forEach(itemset => {
                itemset.classList.remove('d-none');
              })
            }
            item.classList.add('d-none');
          }
        })
      })
    }

}

typeof templateCollectionJS !== 'undefined' && new templateCollectionJS();

 